module.exports = __webpack_public_path__ + "img/bgBox_pc.28f22585.jpg";